const ID = 'pagination';

export default ID;
